const setForPath = (obj, arr, val) => {
 if (typeof arr == 'string') {
   arr = arr.split(".");
 }

 obj[arr[0]] = obj[arr[0]] || {};

 var tmpObj = obj[arr[0]];

 if (arr.length > 1) {
   arr.shift();
   setForPath(tmpObj, arr, val);
 } else {
   obj[arr[0]] = val;
 }

 return obj;
}

const getForPath = (obj, arr) => {
  if (typeof arr == 'string') {
    arr = arr.split(".");
  }

  if (!obj) {
    return null
  }

  var tmpObj = obj[arr[0]];

  if (arr.length > 1) {
    arr.shift();
    return getForPath(tmpObj, arr);
  }

  return obj[arr]
}

export default {

  setForPath,

  getForPath,

}
